import React from "react";
//*import PropTypes from 'prop-types';
import "./linksSkeleton.scss";
//*import { URAvaratSkeleton } from "./skeletonWidgets/avatar";
import { URLineSkeleton } from "./skeletonWidgets/lineSkeleton";
//*import { URboxSkeleton } from "./skeletonWidgets/boxDotSkeleton";
import { URButtonSkeleton } from "./skeletonWidgets/buttonSkeleton";
//*import { URStatusbarSkeleton } from "./skeletonWidgets/statusBarSkeleton";
function URlinksSkeleton(props: any) {
  return (
    <>
      <div className="linksSkeleton">
        <div className="btnSec">
          <URLineSkeleton className='line lineThick size30'/>
          <URButtonSkeleton className='skeletonBtn' />
        </div>
        <div className="btnSec">
          <URLineSkeleton className='line lineThick size60'/>
          <URLineSkeleton className='line lineThin size10'/>
        </div>
        <div className="sss">
          <div className="notesIconbtn"><span className="icon_linkrotate"></span></div>
          <div className="linksBox">
            <div className="notesLine">
              <URLineSkeleton className='line lineThin size95'/>
              <URLineSkeleton className='line lineThin size75'/>
              <URLineSkeleton className='line lineThin size85'/>
              <URLineSkeleton className='line lineThin size90'/>
              <URLineSkeleton className='line lineThin size80'/>
              <URLineSkeleton className='line lineThin size60'/>
            </div>
          </div>
        </div>
      </div>
    </>

  );
}

export {
  URlinksSkeleton
};